import NotificationCard from "../shared/NotificationCard";

export { mapColorCodingToSeverity } from "../shared/severityMappers";

export default function DeNovoCard({
  title = "De Novo UT Product Writers",
  subtitle = "HCPs who have written a referral for a UT therapy for the first time in the last 2 years",
  items = [],
  isLoading = false,
  onExplore,
}) {
  return (
    <NotificationCard
      title={title}
      subtitle={subtitle}
      items={items}
      isLoading={isLoading}
      onExplore={onExplore}
      skeletonVariant="row"
    />
  );
}
